/**
 * Created by mathias.gamperl on 24.06.2015.
 */

export default function () {
  return {
    link: function (scope, elem, attrs) {
      scope.$emit('dcFormLocator', attrs.dcFormLocator);
    }
  };
}



// WEBPACK FOOTER //
// ./src/ui/app/directives/dcFormLocator.js